<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span>Add Transaction</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="transactionForm" (submit)="createTransaction()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Payment Type</label>
                                    <mat-select placeholder="Payment Type" formControlName="payment_type">
                                        <mat-option value="1">IPD</mat-option>
                                        <mat-option value="2">OPD</mat-option>
                                        <mat-option value="3">Health Plan</mat-option>
                                        <mat-option value="4">Lab Test</mat-option>
                                        <mat-option value="5">Scan Book</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Payment Mode</label>
                                    <mat-select placeholder="Payment Mode" formControlName="payment_mode">
                                        <mat-option value="1">RazorPay</mat-option>
                                        <mat-option value="2">Paytm</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Status</label>
                                    <mat-select placeholder="Status" formControlName="status">
                                        <mat-option value="created">Created</mat-option>
                                        <mat-option value="captured">Captured</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Health Plan Id</label>
                                    <input type="text" formControlName="health_plan_id" class="form-control" />

                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Mobile</label>
                                    <input type="text" formControlName="mobile" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Email</label>
                                    <input type="text" formControlName="email" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Payment Link</label>
                                    <input type="text" formControlName="payment_link" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Reference Id</label>
                                    <input type="text" formControlName="reference_id" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Amount</label>
                                    <input type="text" formControlName="amount" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Order Id</label>
                                    <input type="text" formControlName="payment_link_id" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Payment Id</label>
                                    <input type="text" formControlName="payment_id" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Lead Id</label>
                                    <input type="text" formControlName="lead_id" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Lab Lead Id</label>
                                    <input type="text" formControlName="lab_lead_id" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Corporate Lead Id</label>
                                    <input type="text" formControlName="corporate_lead_id" class="form-control" />
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Request Data</label>
                                    <textarea class="form-control" formControlName="request_data"></textarea>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Response Data</label>
                                    <textarea class="form-control" formControlName="response_data"></textarea>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Description</label>
                                    <textarea class="form-control" formControlName="description"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Create Transaction</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>